import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { NavLink } from 'react-router-dom';
import Promo from '../../uikit/Cards/Promo';
import Person from '../../uikit/Cards/Person';
import './SpeakersPage.sass';
import ICropper from '../../interfaces/ICropper';
import { DICTIONARIES } from '../../utils/constants';

import type { SpeakersPageQuery$key } from './__generated__/SpeakersPageQuery.graphql';

interface Props {
	query: SpeakersPageQuery$key;
	labels: {
		[keys: string]: string;
	};
}

interface ISpeaker {
	_id: string;
	_url: string;
	speakerName: string;
	speakerDescription: string;
	speakerPreviewDescription: string;
	facebookLink: string;
	twitterLink: string;
	linkedinLink: string;
	speakerImage: ICropper;
	location: { city: string; countryName: string; country: { _url: string } };
}

function SpeakersPage(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = useFragment(
		graphql`
			fragment SpeakersPageQuery on PublishedContentByTypeQuery {
				home {
					items {
						... on HomePublishedContent {
							stopLookingForSpeakers
						}
					}
				}

				speakers {
					items {
						... on SpeakersPublishedContent {
							_children {
								items {
									... on SpeakerPublishedContent {
										_id
										_url
										speakerName
										speakerPreviewDescription
										speakerImage
										location {
											... on LocationPublishedContent {
												city
												countryName
												country {
													... on FilePublishedMedia {
														_url
													}
												}
											}
										}
										facebookLink
										twitterLink
										linkedinLink
									}
								}
							}
						}
					}
				}
			}
		`,
		props.query
	);
	const { items } = data.speakers.items[0]._children;

	const { stopLookingForSpeakers } = data.home.items[0];

	return (
		<div className="speakers-page">
			<Container>
				<Row className="speakers-page__list">
					{!stopLookingForSpeakers && (
						<Col xs={12} md={4} lg={3} className="speakers-page__item">
							<Promo
								buttonId="speaker_btn"
								isButtonOrange
								buttonText={props.labels[DICTIONARIES.speakersButton]}
								title={props.labels[DICTIONARIES.promoTitle]}
								text={props.labels[DICTIONARIES.promoText]}
								link="/become-a-speaker"
							/>
						</Col>
					)}
					{items.map(
						(speaker) =>
							speaker && (
								<Col
									xs={12}
									md={4}
									lg={3}
									key={speaker._id}
									className="speakers-page__item"
								>
									<Person data={speaker} />
								</Col>
							)
					)}
				</Row>
			</Container>
		</div>
	);
}

export default SpeakersPage;
